import React, { Component } from 'react'

class About extends Component {
	
	// componentDidMount(){
	// 	if(document.getElementById(this.props.match.params.id)){
	// 		console.log(this.props.match.params.id);
	// 		document.getElementById(this.props.match.params.id).scrollIntoView(true);
	// 	}
	// }

	componentDidMount(){
		this.setState({mount:true});
	}

	componentDidUpdate(){
		if(this.state['mount'] && !this.state['route'] && this.props && this.props.location && this.props.location.pathname){

			if(this.props.location.pathname.includes("sorting options")){
				document.getElementById("layout").scrollIntoView(true);window.scrollBy(0, -70);
			}
			else if(this.props.location.pathname.includes("settings")){
				document.getElementById("settings").scrollIntoView(true);window.scrollBy(0, -70);
			}
			else if(this.props.location.pathname.includes("user")){
				document.getElementById("user").scrollIntoView(true);window.scrollBy(0, -70);
			}
			else if(this.props.location.pathname.includes("create")){
				document.getElementById("create").scrollIntoView(true);window.scrollBy(0, -70);
			}
			else if(this.props.location.pathname.includes("edit")){
				document.getElementById("edit").scrollIntoView(true);window.scrollBy(0, -70);
			}
			else if(this.props.location.pathname.includes("points")){
				document.getElementById("points").scrollIntoView(true);window.scrollBy(0, -70);
			}
			else if(this.props.location.pathname.includes("messages")){
				document.getElementById("messages").scrollIntoView(true);window.scrollBy(0, -70);
			}
			else if(this.props.location.pathname.includes("reviews")){
				document.getElementById("reviews").scrollIntoView(true);window.scrollBy(0, -70);
			}
			else if(this.props.location.pathname.includes("issues")){
				document.getElementById("issues").scrollIntoView(true);window.scrollBy(0, -70);
			}
			else if(this.props.location.pathname.includes("tournament")){
				document.getElementById("tournament").scrollIntoView(true);window.scrollBy(0, -70);
			}
			else if(this.props.location.pathname.includes("reddit")){
				document.getElementById("reddit").scrollIntoView(true);window.scrollBy(0, -70);
			}

			this.setState({route:true});
		}
	}
	
	render() {
		return(
			<div style={{display:"flex", flexFlow:"row", justifyContent:"space-around"}}>
				<div id="About" style={{textAlign:"left", padding:"20px", maxWidth:"500px"}} >
					
					<div>
						<a onClick={()=>{document.getElementById("layout").scrollIntoView(true);window.scrollBy(0, -70)}}>sorting options</a><br/>
						<a onClick={()=>{document.getElementById("settings").scrollIntoView(true);window.scrollBy(0, -70)}}>settings</a><br/>
						<a onClick={()=>{document.getElementById("user").scrollIntoView(true);window.scrollBy(0, -70)}}>user dashboard</a><br/>
						<a onClick={()=>{document.getElementById("create").scrollIntoView(true);window.scrollBy(0, -70)}}>create restaurant</a><br/>
						<a onClick={()=>{document.getElementById("edit").scrollIntoView(true);window.scrollBy(0, -70)}}>edit restaurant</a><br/>
						<a onClick={()=>{document.getElementById("points").scrollIntoView(true);window.scrollBy(0, -70)}}>points</a><br/>
						<a onClick={()=>{document.getElementById("messages").scrollIntoView(true);window.scrollBy(0, -70)}}>messages</a><br/>
						<a onClick={()=>{document.getElementById("reviews").scrollIntoView(true);window.scrollBy(0, -70)}}>reviews</a><br/>
						<a onClick={()=>{document.getElementById("issues").scrollIntoView(true);window.scrollBy(0, -70)}}>issues</a><br/>
						<a onClick={()=>{document.getElementById("tournament").scrollIntoView(true);window.scrollBy(0, -70)}}>tournament</a><br/>
						<a onClick={()=>{document.getElementById("reddit").scrollIntoView(true);window.scrollBy(0, -70)}}>reddit</a>
					</div>

					<h3>About this Website</h3>
					
					<p>With all the "gig economy" delivery services available - GrubStreet, EatHub, PostDash, DoorMates,
					whatever... Restaurants have been losing out on a lot of income.</p>
					<p>Many of these restaurants have their own online ordering systems and delivery drivers that are
					available without the 30% or so cut taken straight from them by these predatory companies.</p>
					<p>There is plenty of information available regarding the unethical behavior of these services
					towards their <strike>employees</strike> contracted workers and the restaurants they provide for. </p>
					<p>The point of this website is to offer direct links, aggregated in one location, to restaurants own services
					when available.  Restaurants without their own services will be included but users are encouraged to order off their
					menu via a phone call.</p>
					
					<div id="layout"/>
					<h3>Sorting Options</h3>
					
					<p>The Dashboard will list available restaurants based on the sorting options. </p>
					<p> On larger screens, sorting options will be available on the left side. </p>
					<p>On mobile devices or smaller screens, the sorting options are available in the hamburger menu 
					at the top left of the screen.</p>
					
					<div id="settings"/>
					<h3>Settings</h3>
					
					<p>Found in the hamburger menu on the top left of the screen, there is a link to the settings page.</p>
					<p>Changing your user address and toggling visibility of ads is available on the settings page.</p>
					
					<div id="user"/>
					<h3>User Page</h3>

					<p>The user page is accessible by clicking on the circle with your initials in the top right.</p>
					<p>This is where you will be able to see all of your pending submissions.</p>
					<p>You may delete pending submissions from this page.  Any messages you have for 
					 submissions are also able to be accessed here.</p>
					<p>User Info, Messages, Pending Creations, Pending Edits, Pending Reviews, Issues,
					  and User Reviews can all be found here.</p>
					
					<div id="create"/>
					<h3>Adding a Restaurant</h3>
					
					<p>Adding a restaurant is available in the hamburger menu on the top left of the screen.</p>
					<p>The primary tag should be the food or type of food that the restaurant is most known for.  
					If you add or use a primary tag that does not have an icon associated with it, it will display
					a temporary icon with a question mark.  This is not a problem - I will find and add a corresponding icon for any new 
					tags that are appropriate for an added restaurant.</p>
					<p>Additional tags can be anything relevant to the restaurant, feel free to include as many as
					you can think of.  This can be menu items, types of dishes, or other amenities offered by the 
					restaurant (dartboard, pool table, karaoke, live music, etc.).</p>
					<p>I will open a chat to discuss any unfilled or uncertain portions of the restaurant if needed.</p>


					<div id="edit"/>
					<h3>Editing a Restaurant</h3>

					<p>Restaurants can be edited via a link on the top right of their summary card.  Restrictions
					 on editing restaurants may occur if you have many pending edits that have not been approved, or
					  if you are logged in as a guest.  Restrictions may be lifted based on a users points, or when
					  	pending edits have been approved or removed.  You can always delete a pending edit from
					  your user page, or from the edit link to the restaurant for which you have a pending edit.</p>

					<div id="points"/>
					<h3>Points</h3>

					<p>Users are awarded points for making contributions.  Points allow you to remove ads from 
					the site and increase your capacity for pending contributions.</p>
					<p>Points will be determined on a per-submission basis, but there are some basic guidelines 
					that determine the value of the submission.  New restauarants will be given the highest point 
					values, and restaurants with their own online ordering systems and delivery drivers are prioritized.</p>
					<p>Edits to restaurants that have inaccurate or lacking information is the next priority.  Adding 
					tags is super helpful, especially for non menu item tags like 'dog friendly' or 'pool table', etc.</p>			
					<p>Reviews are appreciated but reviews with just a star rating and either limited or no substance
					in the text are not going to result in points.</p>
					<p>In the future, I hope to offer discounts, promotions, or even profit sharing for content creators via the 
					point system if enough traffic is generated to surpass hosting costs of the webiste.</p>
					
					<div id="messages"/>
					<h3>Messages</h3>

					<p>Messages are chat dialogues opened up by administrators regarding your pending submissions or issues.
					  These chats may be opened to clarify information about your submissions or resolve issues you may have.</p>
					<p>If you have messages available, a message icon will be visible on the circle with your initials
					in the upper right of the screen.</p>
					<p>Messages can be accessed via the user page or via the pending submission that the message concerns.  
					If you are viewing a pending submission that has messages through any page other than the User Page, 
					a message icon will appear at the top right of the submission.  This icon will open the associated 
					messaging chat when clicked on.</p>
					<p>Messages will be archived after the concern involved is resolved.</p> 
					
					<div id="reviews"/>
					<h3>Reviews</h3>

					<p>Users can create reviews for restaurants by clicking on the review link on the restaurants 
					summary card.  Other users reviews will be displayed in the review section of the summary card.
					  </p>
					
					<div id="issues"/>
					<h3>Issues</h3>
					
					<p>If you have any feedback or issues with the site, you can submit them from the Contact & 
					feedback link in the hamburger menu on the top left of the screen.</p>

					<div id="tournament"/>
					<h3>Tournament</h3>

					<p>Tournaments can be started via the link in the hamburger menu at the top left of the screen.</p>
					<p>Currently I have only made single elimination tournament structure available, byes are randomly
					chosen when necessary.</p>
					<p>I intend to add more options for tournaments in the future... see the recent blog post for details</p>

					<div id="reddit"/>
					<h3>Reddit</h3>

					<p>On each restaurant's summary card there is a link to "reddit".</p>
					<p>This will display all reddit comments found with the restaurant title in them.</p>
					<p>This is a work in progress and my first scraping pass gave more than 50,000 comments.</p>
					<p>Some restaurants with names like 'legend', 'heritage', or 'belle' obviously have many 
					comments that aren't actually relevant to the restaurant.  Also some restaurants with names
					that are longer than what people generally refer to them as (e.g. 'Beauvine Burger Concept') have
					limited results.</p>
					<p>I will be working to further expand the reddit data and could use some help in flagging posts
					as 'not relevant', this is available for any user to help with via a 'not relevant' button after each post.</p>


				</div>
			</div>
			);
	}

}

export default About